<div id="course-box">
    <div class="container-fluid">
        <div class="row d-flex justify-content-around">
            <div class="col-12 col-md-2 first">
                <div class="card mx-auto" data-scroll>
                    <img src="/assets/img/infrastructure/Library.jpg" class="card-bg-img" alt="background">
                    <div class="card-overlay"></div>
                    <div class="card-body d-flex justify-content-center align-items-center flex-column">
                        <h6>LIBRARY</h6>
                    </div>
                    <a href="/assets/img/infrastructure/Library.jpg" data-lightbox="counter"
                        class="card-lightbox-link"></a>
                </div>
            </div>
            <div class="col-12 col-md-2 second">
                <div class="card mx-auto" data-scroll>
                    <img src="/assets/img/infrastructure/Computer Lab.jpg" class="card-bg-img" alt="background">
                    <div class="card-overlay"></div>
                    <div class="card-body d-flex justify-content-center align-items-center flex-column">
                        <h6>COMPUTER LAB</h6>
                    </div>
                    <a href="/assets/img/infrastructure/Computer Lab.jpg" data-lightbox="counter"
                        class="card-lightbox-link"></a>
                </div>
            </div>
            <div class="col-12 col-md-2 third">
                <div class="card mx-auto" data-scroll>
                    <img src="/assets/img/infrastructure/Biology.jpg" class="card-bg-img" alt="background">
                    <div class="card-overlay"></div>
                    <div class="card-body d-flex justify-content-center align-items-center flex-column">
                        <h6>BIO LAB</h6>
                    </div>
                    <a href="/assets/img/infrastructure/Biology.jpg" data-lightbox="counter" class="card-lightbox-link"></a>
                </div>
            </div>
            <div class="col-12 col-md-2 second">
                <div class="card mx-auto" data-scroll>
                    <img src="/assets/img/infrastructure/Physics Lab.jpg" class="card-bg-img" alt="background">
                    <div class="card-overlay"></div>
                    <div class="card-body d-flex justify-content-center align-items-center flex-column">
                        <h6>PHYSICS LAB</h6>
                    </div>
                    <a href="/assets/img/infrastructure/Physics Lab.jpg" data-lightbox="counter"
                        class="card-lightbox-link"></a>
                </div>
            </div>
            <div class="col-12 col-md-2 first">
                <div class="card mx-auto" data-scroll>
                    <img src="/assets/img/infrastructure/Chemistry Lab.jpg" class="card-bg-img" alt="background">
                    <div class="card-overlay"></div>
                    <div class="card-body d-flex justify-content-center align-items-center flex-column">
                        <h6>CHEMISTRY LAB</h6>
                    </div>
                    <a href="/assets/img/infrastructure/Chemistry Lab.jpg" data-lightbox="counter"
                        class="card-lightbox-link"></a>
                </div>
            </div>
        </div>
    </div>
</div>